export const UPDATE_PAGE_MESSAGES = 'UPDATE_PAGE_MESSAGES';
export const UPDATE_COMPLEX_MESSAGES = 'UPDATE_COMPLEX_MESSAGES';
export const UPDATE_JS_MESSAGES = 'UPDATE_JS_MESSAGES';
export const UPDATE_HEADER_TITLE = 'UPDATE_HEADER_TITLE';
export const UPDATE_HEADER_INFO = 'UPDATE_HEADER_INFO';
export const UPDATE_HEADER_GRAY_TITLE = 'UPDATE_HEADER_GRAY_TITLE';

export const updatePageMessages = (pageMessages) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_PAGE_MESSAGES,
                pageMessages: pageMessages,
            }),
        );
    };
};
export const updateComplexMessages = (complexMessages) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_COMPLEX_MESSAGES,
                complexMessages: complexMessages,
            }),
        );
    };
};
export const updateJsMessages = (jsMessages) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_JS_MESSAGES,
                jsMessages: jsMessages,
            }),
        );
    };
};
export const updateHeaderTitle = (headerTitle) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_HEADER_TITLE,
                headerTitle: headerTitle,
            }),
        );
    };
};
export const updateHeaderInfo = (headerInfo) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_HEADER_INFO,
                headerInfo: headerInfo,
            }),
        );
    };
};

export const updateHeaderGrayTitle = (headerGrayTitle) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_HEADER_GRAY_TITLE,
                headerGrayTitle: headerGrayTitle,
            }),
        );
    };
};
